export default {
  nav: {
    home: '首页',
    templates: '模板市场',
    login: '登录',
    logout: '退出',
    account: '账号',
    help: '帮助中心',
    terms: '服务条款',
    privacy: '隐私政策',
    refund: '退款政策',
  },
  home: {
    title: '买一套模板，得一个独立站点',
    subtitle: '每个站点都是你自己的 Cloudflare Pages 项目 + 自己的数据库 + 自己的后台，不共享、不托管、随时可迁走。',
    ctaBrowse: '浏览模板',
    ctaFeatured: '精选模板',
    featuresTitle: '交付形态',
    features: {
      f1: { title: '独立部署', body: '站点跑在你自己的 Cloudflare 账号下，Pages 项目与 D1 数据库都归你。' },
      f2: { title: '站点后台', body: '文案、图片、SEO、语言、表单收件箱都在后台改，不需要重新构建。' },
      f3: { title: '双语内容', body: '同一站点多语言内容并存，语言清单由平台 locales 表驱动。' },
      f4: { title: '可持续升级', body: '模板与站点后端各自有版本线，升级走灰度，出问题可回滚。' },
    },
    prereqTitle: '部署前请确认（平台不代管账号）',
    prereqFree: '额度水位',
    prereqToken: '所需的 API Token 权限',
    d1Limit: '每个账号的 D1 数据库上限',
    pagesLimit: '每个账号的 Pages 项目上限',
    prereqNote: '部署会用你的 Token 在你的账号里建项目与库；额度不足时平台会在预检阶段直接拒绝，不会产生半成品站点。',
  },
  list: {
    title: '模板市场',
    search: '搜索模板名称/简介',
    searchBtn: '搜索',
    category: '分类',
    categoryAll: '全部分类',
    tags: '标签',
    featuredOnly: '只看精选',
    clear: '清除筛选',
    empty: '没有符合条件的模板',
    loadMore: '加载更多',
    sites: '{n} 个站点',
    langs: '{n} 种语言',
    from: '起价',
    preview: '预览',
    detail: '查看详情',
  },
  detail: {
    back: '返回列表',
    version: '当前版本',
    priceTitle: '价格',
    buy: '立即购买并部署',
    buyLogin: '登录后购买',
    buyHint: '结算与部署向导在下一迭代接入；现在可先用预览确认站点效果。',
    adminTitle: '站点后台可改内容（{n} 项）',
    adminHint: '以下条目来自模板的内容契约，不是人工罗列 —— 模板改契约，这里就跟着变。',
    field: '字段',
    fieldType: '类型',
    required: '必填',
    i18nScoped: '按语言',
    versionsTitle: '版本记录',
    versionStatus: '状态',
    versionSiteBackend: '站点后端',
    breaking: '含破坏性变更',
    yes: '是',
    no: '否',
    demoSite: '演示站点',
    priceMissing: '未定价（请先在后台配价格）',
  },
  preview: {
    title: '实时预览（SSR 出真实内容）',
    desktop: '桌面',
    tablet: '平板',
    mobile: '手机',
    openNew: '新窗口打开',
    loading: '正在加载预览…',
    blocked: '预览站点未能加载',
    blockedHint: '预览项目需要先在模板仓打 tag 构建，并由本地预览服务（http://localhost:5175）提供 SSR。',
    draftBadge: '预览版（带水印，表单已禁用）',
    notBuilt: '该模板还没有可用的预览项目（模板仓尚未打 tag 构建）',
  },
  auth: {
    loginTitle: '登录平台账号',
    registerTitle: '注册新账号',
    email: '邮箱',
    password: '密码',
    doLogin: '登录',
    doRegister: '注册并登录',
    switchToRegister: '没有账号？注册',
    switchToLogin: '已有账号？登录',
    loggedInAs: '已登录：{email}',
    registerHint: '注册即时生效（本地环境直接回显邮箱验证串，无需真实邮件）。',
    errBad: '邮箱或密码不正确（{code}）',
  },
  notFound: {
    body: '这个地址在站点上不存在。可能是语言前缀或模板 slug 写错了。',
  },
  a7: {
    title: '下单前请知情',
    lede: '平台不代管你的 Cloudflare 账号；站点、数据库、后台都开在你自己的 CF 项目下。下单前请逐项确认下面事项。',
    needTitle: '你需要自备的 CF 资源',
    needCf: '一个可正常登录的 Cloudflare 账号（建议已开 2FA）。',
    needPages: 'Pages 项目额度：免费计划 100 项目；一张授权 = 一个 Pages 项目。',
    needD1: 'D1 数据库额度：免费计划 10 个库；一张授权 = 一个 D1 库。',
    needSecrets: 'Secrets / Variables：部署会写入你的 Pages 项目，平台不代存。',
    capacityTitle: '适合的业务体量（保守口径，依 PoC⑩ 终审）',
    capacityBody:
      '本模板 + Pages + D1 按“每次浏览约 4 个绑定调用”计量（PoC⑩ 实测：单次前台 SSR ≤ 4 子请求）。在 Cloudflare 免费档（约 10 万 Worker 请求/日）下，稳定支撑约 ≤ 2.5 万 PV/日 的低并发企业官网；超过约 2.5 万 PV/日需升级 CF 付费档。高流量门户、大型商城、CDN 回源遮蔽、多区多活均不在支持范围，请自建基础设施。',
    licenseTitle: '“服务资格”不是“软件许可”',
    licenseBody:
      '你买的是“模板内容 + 后台使用 + 升级推送”的服务资格；模板一旦下发即可永久自用。平台只停“后续更新与支持”，绝不会隔空关你的站点。',
    dataTitle: '数据归属',
    dataBody: '内容、表单、图片都在你自己的 D1/R2，平台不存副本。平台只存你账户邮箱/订单/授权 hash 与部署历史。',
  },
  a10: {
    title: '平台服务条款',
    lede: '最后更新：2026-10-23（v1.0 生效版）。以下为双方权利义务基线；容量口径依据 PoC⑩ 终审（见 A7）。',
    s1: '一、服务性质',
    s1Body:
      '平台提供模板内容交付与部署辅助，不构成云基础设施服务；站点、数据库与后台均运行在买家自有 Cloudflare 账号内。',
    s2: '二、账号与额度',
    s2Body:
      '买家需自备 Cloudflare 账号，部署使用买家额度；平台不代付 CF 费用，买家账号超限/欠费导致的停摆不属平台责任。',
    s3: '三、退款与吊销',
    s3Body:
      '自付款之日起 7 天内、且尚未成功部署首个站点的，可申请全额退款；一旦完成部署即视为服务资格已交付，不再退款，但可随时停止续费。授权吊销仅停止后续更新与支持，绝不远程关停站点、不删除买家数据。',
    s4: '四、内容归属',
    s4Body: '买家通过后台录入的文字、图片归买家所有；模板自带素材为平台授权给买家的一次性商用许可。',
    s5: '五、责任限制',
    s5Body:
      '因 CF 服务中断、买家 Token 泄露、买家自行修改代码（含修改 _worker.js）导致的损失，平台不承担责任；不提供源码下载，修改产物后不支持。',
    s6: '六、升级与兼容',
    s6Body:
      '平台承诺“主要版本不强制升级”；买家可锁定当前版本，平台仅提供升级推送建议与回滚文档。授权到期只影响更新与支持。',
  },
  a9: {
    title: '帮助中心',
    lede: '面向“不熟 CF 的买家运营”：注册、Token 授权、后台使用、自定义域、应急路径。',
    cfTitle: '① Cloudflare 账号注册',
    cf1: '访问 dash.cloudflare.com，邮箱+密码注册（可选 Google/GitHub 登录）。',
    cf2: '验证邮箱，开启两步验证（推荐身份验证器 App）。',
    cf3: '首次登录后进 “Account Home”，复制 Account ID（部署向导会用到）。',
    tokenTitle: '② API Token 三项权限（最小面）',
    tokenLede: '平台仅需三项权限，不索取全局写权；创建入口：My Profile → API Tokens → Create Token。',
    token1: 'Pages: Edit（建/改 Pages 项目、上传产物、写 Secrets/Variables）。',
    token2: 'D1: Edit（在账号内建/删库、跑迁移、读额度）。',
    token3: 'Account Settings: Read（只读账号级设置与自定义域状态；不写 DNS，需买家自己到 CF DNS 页手动加 CNAME）。',
    tokenHint: '创建后仅展示一次，平台写部署向导的 Token 输入框时即时校验；不保留密文，B7 “不留存 Token” 默认开启。',
    conceptsTitle: '③ Pages / D1 / Secrets 概念一页掌',
    conceptsPages: 'Pages = 一个前端项目 + Workers 高级模式；站点产物与 _worker.js 都属 Pages。',
    conceptsD1: 'D1 = CF 的 SQLite Serverless，一个 Pages 项目绑一个库；数据完全归买家。',
    conceptsSecrets: 'Secrets/Variables = Pages 项目的环境变量；平台写入 LICENSE_KEY、BINDING_ID、PLATFORM_API_BASE。',
    adminTitle: '④ 站点后台使用手册（面向买家运营）',
    adminBody:
      '登录入口：你的站点地址 + /__admin；口令只在部署邮件里一次性展示，登录后建议立即启用 Passkey（Windows Hello / YubiKey / Face ID）。内容修改实时写入买家 D1，前台下一次访问即生效。',
    domainTitle: '⑤ 自定义域名（不代写 DNS）',
    domainBody:
      '平台仅代建 Pages 项目与默认 *.pages.dev 域名。买家可在 CF Pages → Custom domains 手动加域名，按提示在自己的 DNS 里建 CNAME；平台不代写 DNS 记录。',
    lockoutTitle: '⑥ 丢失全部管理员账号的应急路径',
    lockoutBody:
      '站点后台 = 买家自有 D1；平台不存后台口令。应急可凭自己的 CF 账号 + D1 CLI 直接执行 UPDATE site_admins SET locked_until=NULL, failed_attempts=0 解锁；也可以请平台客服指导“重建一个 owner”（需验证站点归属：使用部署时同一个 D1 库 ID）。',
  },
  app: {
    tabOrders: '我的订单',
    tabLicenses: '我的授权',
    tabDeploy: '部署引导',
    tabSites: '站点清单',
    tabUpdates: '可更新列表',
    needLogin: '请先登录（右上角“登录”）。',
    ordersTitle: '我的订单',
    ordersEmpty: '暂无订单。',
    licensesTitle: '我的授权（服务资格）',
    licensesEmpty: '暂无授权。',
    qualificationNote: '“服务资格”只影响后续更新与技术支持；平台不隔空关你的站点。',
    qualifiedActive: '服务资格：正常',
    qualifiedExpiring: '服务资格：即将到期',
    qualifiedLapsed: '服务资格：已停（不影响站点在线）',
    deployTitle: '部署引导（三步）',
    deployStep1: '创建 API Token（仅 Pages:Edit + D1:Edit + Account Settings:Read）。',
    deployStep2: '粘贴 Token 后平台会即时校验，确认账号内剩余额度。',
    deployStep3: '选择绑定域名与初始内容，平台在你的 CF 项目里完成 Pages + D1 + Secrets 部署。',
    deployHint: '前置检查失败时，平台会直接转成引导文案（不会只报 500）。',
    deployHelp: '打开帮助中心',
    sitesTitle: '站点清单',
    sitesEmpty: '暂无部署。',
    sitesAckHint: '初始账号仅在你的部署邮件里一次性展示；本页只提供“已阅知确认”，绝不重复展示口令。',
    ackBtn: '我已保存初始账号',
    ackDone: '已确认',
    updatesTitle: '可更新列表',
    updatesEmpty: '暂无部署。',
    updatesHint: '模板与站点后端两条版本线相互独立；平台不会静默升级，只推送提醒。',
    colId: 'ID',
    colTemplate: '模板',
    colAmount: '金额',
    colStatus: '状态',
    colCreated: '时间',
    colSite: '站点地址',
    colAdmin: '后台地址',
    colAckAccount: '初始账号',
    colTemplateLine: '模板线',
    colBackendLine: '后端线',

    /* ---- 本次补全：B1/B4/B5/B6/B7/B9/B11/B12 的界面文案 ---- */
    tab: {
      profile: '账户资料',
      orders: '我的订单',
      licenses: '我的授权',
      deploy: '绑定与部署',
      sites: '我的站点',
      health: '站点健康',
      logs: '使用记录',
      support: '人工协助',
    },
    profileTitle: '账户资料',
    email: '邮箱',
    emailLocked: '邮箱是账号找回的唯一凭据，修改需重新验证邮箱所有权（当前不支持在线改邮箱）。',
    verified: '邮箱已验证',
    unverified: '邮箱未验证（请查收验证邮件）',
    nickname: '昵称',
    companyName: '企业名称（可选）',
    defaultLocale: '默认语言',
    saveProfile: '保存资料',
    profileSaved: '资料已保存。',
    passwordTitle: '修改登录口令',
    currentPassword: '当前口令',
    newPassword: '新口令（至少 10 位）',
    changePassword: '修改口令',
    passwordChanged: '口令已修改；其他设备上的登录将在 15 分钟内失效。',
    passwordHint: '修改口令需要旧口令校验，不会通过邮件发临时口令。',

    bindTitle: '绑定 Cloudflare 账号并部署',
    bindIntro:
      '平台会用你的 API Token 在你自己的 Cloudflare 账号内创建 Pages 项目与 D1 数据库。Token 只用于部署，不用于任何读取你内容的操作。',
    bindLicense: '选择授权',
    bindFormTitle: '提交 Cloudflare 凭据',
    cfAccountId: 'Cloudflare Account ID',
    cfApiToken: 'API Token',
    tokenRetainedLabel: '保留 Token 以支持后续升级（推荐）',
    tokenRetainedHint: '关闭后：部署成功即物理删除密文，之后每次升级都需要你重新粘贴 Token（高安全档）。',
    requiredPerms: 'Token 需要的权限（三项，缺一不可）',
    createToken: '打开 Cloudflare 创建 Token（已预填权限）',
    bindSubmit: '校验并绑定',
    bindOk: '绑定成功。',
    bindGranted: '实际授予的权限：',
    goDeploy: '去触发首次部署',
    quotaFull: '该授权下的站点数已达上限；如需增加站点请先追加订单。',
    bindingsTitle: '已绑定站点',
    noBindings: '该授权下还没有绑定。',
    unbind: '解绑',
    unbindConfirm: '解绑会停止该站点的后续升级与支持，站点本身仍在你账号内运行。确定继续？',
    unbound: '已解绑。',
    dropToken: '改为不保留',
    retainToken: '保留 Token',
    tokenKept: '已留存密文（可代部署升级）',
    tokenDropped: '未留存（升级需重新授权）',
    unbindHint: '解绑不会撤下你的站点、不迁移内容；平台不代付 Cloudflare 费用，旧站点需你自行处置。',
    colTokenStatus: 'Token 状态',
    colDeployStatus: '最近部署',
    colVersion: '版本（模板 / 后端）',
    colQualification: '服务资格',
    colExpires: '到期',
    colSitesQuota: '站点额度',
    colLangsQuota: '语言额度',
    colKind: '类别',
    colEvent: '事件',
    colError: '错误码',
    colLine: '版本线',
    colStep: '步骤',
    bindNow: '绑定/部署',

    sitesIntro: '站点清单只提供访问地址与后台地址；源码不下发，入口内容在站点后台（/__admin）维护。',
    refresh: '刷新',
    deployHistory: '部署历史',
    emptyDeploy: '暂无部署记录。',
    claimCreds: '领取初始后台口令',
    credsTitle: '站点后台初始账号（仅显示一次）',
    credsOnce: '关闭后无法再次查看；平台不保存明文口令。请立即登录并修改。',
    noDeployment: '该站点还没有部署记录。',
    upgradeQueued: '升级任务已入队，页面会自动刷新状态。',
    updateTemplate: '升级模板线',
    updateBackend: '升级后端线',
    goHealth: '查看站点健康',
    goSupport: '需要人工协助',

    healthTitle: '站点健康与额度',
    healthIntro: '左栏是平台能直接观测的信号；右栏是站点自计数经心跳上报的额度单位。两栏不可相加，也不折算成 PV。',
    noteHeartbeat: '心跳口径：',
    noteUnits: '额度单位：',
    noteThreshold: '免费档阈值：',
    liveNow: '心跳正常',
    notLive: '心跳中断',
    platformSide: '平台侧（可直接观测）',
    buyerSide: '买家侧上报（自计数）',
    buyerNoData: '该站点尚未上报过自计数（首次部署后 24 小时内出现）。',
    quotaUnits: '额度单位 / 每日上限',
    d1ReadWrite: 'D1 读 / 写行数',
    reportedAt: '上报时间',
    source: '数据来源',
    buyerSelfReported: '★ 自计数可能不准，也可能被站点侧修改；平台不对其准确性作承诺。',
    lastHeartbeat: '最近心跳',
    lastDeploy: '最近部署',
    warn: {
      binding_inactive: '绑定状态异常，升级能力已失效',
      heartbeat_stale: '超过 36 小时未上报心跳',
      quota_80: '额度已用超过 80%',
      quota_exceeded: '额度已达上限，当天站点可能不可用',
    },

    logsTitle: '使用记录',
    logsIntro: '授权事件与部署历史合并成一条时间线，用于自助排障。',
    logsEmpty: '暂无记录。',
    logDeploy: '部署',
    logLicense: '授权',

    supportTitle: '人工协助绑定',
    supportIntro:
      '如果 Token 一直校验不过，可提交工单由运营协助（图文或屏幕共享）。多数失败是漏勾权限，请先按下面三项核对。',
    supportKind: '问题类型',
    supportSeverity: '紧急程度',
    supportContact: '联系方式',
    supportContactHint: '邮箱 / 微信号 / 可约时间',
    supportMessage: '问题描述',
    supportSubmit: '提交工单',
    supportSent: '工单已提交，预期首次响应：',
    supportMine: '我的工单',
    supportEmpty: '还没有工单。',
    supportTokenWarn:
      '★ 请勿在工单中粘贴 API Token（整串字母数字）；正文含 Token 形态的内容会被拒绝。协助过程仍走加密绑定表单。',
    noLicense: '（不关联授权）',
    severityShort: '优先级',
    kind: {
      assist_bind: '人工协助绑定',
      deploy_failure: '部署失败排查',
      token_permission: 'Token 权限问题',
      other: '其他',
    },
    sev: { low: '低', normal: '普通', high: '高' },
    tstatus: { open: '待处理', in_progress: '处理中', resolved: '已解决', closed: '已关闭' },
  },
  privacy: {
    title: '隐私政策',
    lede: '最后更新：2026-10-23（v1.0 生效版）。本页说明平台收集什么、不收集什么，以及你的数据在哪里。',
    s1: '一、平台收集的信息',
    s1Body:
      '邮箱、口令哈希（PBKDF2，不可逆）、订单与授权记录（授权 key 只存 SHA-256 哈希）、部署任务记录（状态/步骤/错误码）、运营与用户关键操作审计（IP 与请求 ID）。平台不收集身份证号、手机号与支付卡号；支付卡信息由支付通道直接处理，不经过平台。',
    s2: '二、平台不收集的信息（v2.0 告知）',
    s2Body:
      '站点文案、图片、表单留言、站点管理员账号与会话全部存在你自己 Cloudflare 账号的 D1/R2 中。平台既无法读取，也无法代为备份或恢复；请自行在 Cloudflare Dashboard 侧做好备份。',
    s3: '三、API Token 与密钥',
    s3Body:
      '你的 Cloudflare API Token 以 AES-256-GCM 加密存库，解密密钥保存在 Cloudflare Secret 中，不随代码与数据库泄露。开启「不留存 Token」后，部署完成即物理删除密文；平台不会用你的 Token 执行部署以外的操作。',
    s4: '四、第三方处理者',
    s4Body:
      'Cloudflare（托管与部署）、支付通道（Stripe / PayPal）、邮件服务（Resend）。除完成上述服务所必需外，不向任何第三方提供你的数据；不用于广告画像与转卖。',
    s5: '五、保留期',
    s5Body:
      '账号数据在账号存续期间保留；删除账号后 30 天内清除个人标识，订单与审计记录按合规要求保留 12 个月（仅保留金额、时间与操作类型）。',
    s6: '六、你的权利',
    s6Body:
      '可通过用户中心「人工协助」提交工单，申请导出或删除账户数据。删除后平台侧不可恢复；站点数据在你自己的账号内，不受影响。',
  },
  refund: {
    title: '退款政策',
    lede: '最后更新：2026-10-23（v1.0 生效版）。与《服务条款》第三节一致，本节给出可执行的判定与流程。',
    s1: '一、7 天未部署全额退',
    s1Body: '自付款之日起 7 天内、且尚未成功部署首个站点的，可申请全额退款，无需说明理由。',
    s2: '二、已部署不退',
    s2Body: '一旦完成首次部署即视为服务资格已交付（含模板内容、站点后台与升级推送），不再退款；订阅制可随时停止续费。',
    s3: '三、部署失败的例外',
    s3Body:
      '因平台原因（产物损坏、编排缺陷）连续部署失败且无法修复的，全额退款；因买家 Token 权限不足、账号额度耗尽或欠费导致的失败，平台协助排查后仍无法完成部署的，按未交付处理退款。',
    s4: '四、订阅与续费',
    s4Body:
      '订阅制按周期扣款，可在下次扣款前取消；已开始的计费周期原则上不退，未使用部分可申请按比例退还（需人工审核）。',
    s5: '五、如何申请',
    s5Body:
      '在用户中心「人工协助」提交工单，选择“其他”并在正文注明订单号与退款原因；3 个工作日内答复，退款退回原支付通道（到账时间由通道决定）。',
    s6: '六、吊销不等于退款',
    s6Body: '授权被吊销或到期只停止后续更新与技术支持，不触发退款，也不影响站点继续在线运行。',
  },
  common: {
    loading: '加载中…',
    retry: '重试',
    error: '请求失败',
    errorNetwork: '无法连接平台 API（{base}）。请先启动：pnpm api:dev',
    errorLocale: '该语言尚未安装：{got}（可选：{supported}）',
    close: '关闭',
  },
};
